import { useRef, useCallback } from 'react';

// Race-condition guard pour les fetchs successifs (recherche, filtres rapides).
// Si l'utilisateur déclenche plusieurs fetchs rapidement, seul le résultat
// du DERNIER appel sera appliqué via la callback `onResult`. Les réponses
// arrivées dans le désordre sont ignorées.
//
// Pourquoi : avec useEffect([filtre]) qui appelle fetch(), une réponse lente
// peut écraser une réponse plus récente déjà arrivée. Symptôme : on tape vite
// et la liste affiche un résultat ancien.
//
// Usage :
//   const guarded = useLatestFetch();
//   const load = async () => {
//     await guarded(
//       () => service.getAll(params),       // l'appel async
//       (data) => setItems(data?.items),    // appliqué seulement si c'est le plus récent
//     );
//   };
const useLatestFetch = () => {
    const counterRef = useRef(0);

    const run = useCallback(async (fetcher, onResult, onError) => {
        const myId = ++counterRef.current;
        try {
            const res = await fetcher();
            if (myId !== counterRef.current) return; // une requête plus récente est en cours
            onResult?.(res);
            return res;
        } catch (err) {
            if (myId !== counterRef.current) return;
            onError?.(err);
            throw err;
        }
    }, []);

    return run;
};

export default useLatestFetch;
